/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Kind_SwitchInputs */

const en_us2_gyms_kind_switch = /** @type {(inputs: Gyms_Kind_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym switch`)
};

const pt_br2_gyms_kind_switch = /** @type {(inputs: Gyms_Kind_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troca de academia`)
};

const es_419_gyms_kind_switch = /** @type {(inputs: Gyms_Kind_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de gimnasio`)
};

const pt_pt2_gyms_kind_switch = /** @type {(inputs: Gyms_Kind_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troca de ginásio`)
};

const fr_fr2_gyms_kind_switch = /** @type {(inputs: Gyms_Kind_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changement de salle`)
};

const de_de2_gyms_kind_switch = /** @type {(inputs: Gyms_Kind_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studiowechsel`)
};

const it_it2_gyms_kind_switch = /** @type {(inputs: Gyms_Kind_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio palestra`)
};

/**
* | output |
* | --- |
* | "Gym switch" |
*
* @param {Gyms_Kind_SwitchInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_kind_switch = /** @type {((inputs?: Gyms_Kind_SwitchInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Kind_SwitchInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_kind_switch(inputs)
	if (locale === "es-419") return es_419_gyms_kind_switch(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_kind_switch(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_kind_switch(inputs)
	if (locale === "de-DE") return de_de2_gyms_kind_switch(inputs)
	if (locale === "it-IT") return it_it2_gyms_kind_switch(inputs)
	return en_us2_gyms_kind_switch(inputs)
});
export { gyms_kind_switch as "gyms.kind_switch" }